import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ClarityModule } from '@clr/angular';
import { ModuleWithProviders } from '@angular/compiler/src/core';

import { AuthConfig } from './auth.config';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { AuthService } from './services/auth.service';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { LoginGuard } from './services/login.guard';
import { OidcLoginComponent } from './pages/oidc-login/oidc-login.component';
import { OidcLoginGuard } from './services/oidc-login.guard';
import { FeatureFlagService } from './services/feature-flag.service';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'oidc-login',
        component: OidcLoginComponent,
        canActivate: [OidcLoginGuard],
      },
    ],
  },
];

export function initApp(feature_flag_service: FeatureFlagService) {
  return () => feature_flag_service.start();
}

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [AuthService, AuthGuard, FeatureFlagService],
})
export class AuthModule {
  static forRoot(config: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        FeatureFlagService,
        {
          // Init the app with feature flags
          // because feature flags must be ready before all the other services
          provide: APP_INITIALIZER,
          useFactory: initApp,
          deps: [FeatureFlagService],
          multi: true,
        },
        AuthService,
        AuthGuard,
        {
          provide: 'config',
          useValue: config,
        },
      ],
    };
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ClarityModule,
  ],
  declarations: [AuthComponent, LoginComponent, LogoutComponent, OidcLoginComponent],
})
export class AuthViewModule { }
